<template>
  <b-modal
    id="customer-bonuses-points"
    hide-footer
    title="
     افزایش یا کاهش بن و امتیاز مشتری
    "
  >
    <form autocomplete="off" @submit.prevent="changeBonusesPoints">
      <b-form-group>
        <label class="pb-1" for="">
          نوع تراکنش<i class="text-danger">*</i></label
        >
        <b-form-select id="type" @change="changrTransactionType" v-model="type">
          <b-form-select-option value="increment">افزایش</b-form-select-option>
          <b-form-select-option value="decrement">کاهش</b-form-select-option>
        </b-form-select>
      </b-form-group>
      <div class="d-flex w-100 justify-content-between">
        <b-form-group>
          <label class="pb-1" for=""> میزان امتیاز </label>
          <b-form-input
            :value="score_value"
            @input="
              (value) => {
                score_value = value !== '' ? +value.replace(/\D/g, '') : '';
              }
            "
          >
          </b-form-input>
        </b-form-group>
        <b-form-group>
          <label class="pb-1" for=""> میزان بن </label>
          <b-form-input
            :value="bon_value"
            @input="
              (value) => {
                bon_value = value !== '' ? +value.replace(/\D/g, '') : '';
              }
            "
          >
          </b-form-input>
        </b-form-group>
      </div>
      <b-form-group>
        <label class="pb-1" for=""> توضیحات <i class="text-danger">*</i></label>
        <b-form-textarea v-model="cause"></b-form-textarea>
      </b-form-group>
      <div class="w-100 d-flex justify-content-center">
        <button
          @click="changeBonusesPoints"
          class="btn btn-success"
          :disabled="disabled"
          :class="{ disabledBtn: disabled }"
        >
          ارسال تراکنش
        </button>
      </div>
      <!-- <b-form-group v-if="wallet">
        <label class="pb-1" for="">
          مبلغ (تومان) <i class="text-danger">*</i></label
        >
        <b-form-input
          :value="wallet.amount | priceinput"
          @input="
            (value) => {
              wallet.amount = value !== '' ? +value.replace(/\D/g, '') : '';
            }
          "
        >
        </b-form-input>
      </b-form-group>
      <b-form-group>
        <label class="pb-1" for=""> توضیحات </label>
        <b-form-textarea v-model="description"></b-form-textarea>
      </b-form-group>

      <b-form-group>
        <b-form-checkbox v-model="is_gift" name="is_gift" :disabled="disabled">
          <span class="pr-5">
            {{
              type == "deposit" ? "افزایش موجودی هدیه " : "کاهش موجودی هدیه "
            }}
          </span>
        </b-form-checkbox>
      </b-form-group>
      <div class="text-center  mt-3">
        <button
          v-if="type == 'deposit'"
          class="btn btn-success"
          :disabled="disabled"
        >
          افزایش موجودی
        </button>
        <button
          v-else-if="type == 'withdraw'"
          class="btn btn-danger"
          :disabled="disabled"
        >
          کاهش موجودی
        </button>
      </div> -->
    </form>
  </b-modal>
</template>
<script>
import CustomerBonusesPointsImpl from "@@/core/components/customer/CustomerBonusesPoints/CustomerBonusesPointsImpl";
export default {
  extends: CustomerBonusesPointsImpl,
};
</script>
<style scoped>
.disabledBtn {
  opacity: 0.5;
  cursor: not-allowed !important;
}
</style>
